/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 7/17/20
 * Time: 8:46 AM
 */
/* eslint-disable*/
import React from "react";
import {Col, Container, Row} from "reactstrap";
// core components
import CardsFooter from "../../../components/Modals/Footers/CardsFooter.js";
import Header from '../../../components/Header/Header';
import './Teacher.scss';
import CourseSlides from "../../../components/CourseSlides/CourseSlides";
import SectionPolygon from "../../../components/SectionPolygon/SectionPolygon";
import connect from "react-redux/es/connect/connect";
import {withRouter} from "react-router";
import * as instituteService from "../../../services/institute";
import * as commonFunc from "../../../utils/commonFunc";
import * as actionSpinnerCreator from "../../../store/domain/spinner/action";
import * as actionClassCreator from "../../../store/domain/classes/action";
import * as actionLectureCreator from "../../../store/domain/lecturer/action";
import NotFound from "../../../components/NotFound/NotFound";
import {lang, language} from "../../../const/language";
import AuthButtonGroup from "../../../components/AuthButtonGroup/AuthButtonGroup";
import LessonItem from "../../../components/LessonItem/LessonItem";
import i from "react-icofont";

class Teacher extends React.Component {

    state = {
        lessons: [],
        classes: [],
        privileges: '0'
    }

    fetchClassesFromHome = async (pageNo) => {
        this.props.spinnerHandler({isSpin: true, type: 15});

        await instituteService.getTeacherDetails(1)
            .then(response => {
                this.props.spinnerHandler(false);
                if (response.success) {
                    let body = response.body;
                    let data = [{
                        classes: body.classes,
                        teacherId: body.id,
                        teacherName: body.name
                    }];
                    this.props.fetchLecture({
                        name: body.name,
                        about: body.description,
                        image: body.imageUrl,
                        defaultImage: '',
                        qualification: body.qualification,
                        privileges: body.privileges,
                        coverImage: body.coverImage,
                    })
                    this.props.fetchLectures(data);
                    this.setState({
                        lessons: body.lessons,
                        classes: body.classes,
                        privileges: body.privileges.split(':')[1]
                    })
                } else {
                    commonFunc.notifyMessage(response.message, response.status)
                }
            })
    };

    componentDidMount() {
        document.documentElement.scrollTop = 0;
        document.scrollingElement.scrollTop = 0;
        this.refs.main.scrollTop = 0;
        this.fetchClassesFromHome(null);
    }

    render() {
        let {lecturer, listOfLectures, userType} = this.props;
        if (this.state.classes && this.state.classes !== 0) {
            this.state.classes.sort(function (a, b) {
                return a.id - b.id
            });
        }
        const cover = 'https://assets.edulab.lk/common-assets/banner-bg.jpg';

        return (
            <div>
                <Header active={0}/>
                <main ref="main" className={"main"}>

                    <section className="profile-layer">
                        <img
                            src={lecturer.coverImage ? lecturer.coverImage : cover}
                            alt={"."}
                            className={"blur-img"}/>
                        <img
                            src={lecturer.coverImage ? lecturer.coverImage : cover}
                            alt={"."}
                            className={"slideshow-pro-image"}/>


                        <img src={lecturer.image} className={"profile-image"} alt="."/>

                    </section>
                    <section className="section name pb-0">

                        <div className="about mb-3 pl-lg-8 pr-lg-8 pb-2">
                            <h3 className={"name-row1"}>{lecturer.name}</h3>
                            <p className={"name-row2 none-margin_"}>{lecturer.qualification}</p>
                            <p className={"name-row2 none-margin_"}><i className="icofont-phone"/> 0711217025 / 0701217025</p>
                            <AuthButtonGroup userType={userType}/>
                        </div>
                    </section>

                    <section className="section pt-0">
                        <div className="about2">
                            <h3 className={"class-topic"}>{language[lang].About}</h3>
                            {/*<p className={"about-para"}>{lecturer.about}</p>*/}
                            <p className={"about-para"}>
                                <div>
                                    <p className={"none-margin_ text-align-justify"}>පිට පිට වසර තුනක් දිස්ත්‍රික්
                                        ප්‍රථමයා බිහිකල අතර මෙවර රත්නපුර දිස්ත්‍රික් ප්‍රථමයා මෙන්ම හම්බන්තොට
                                        දිස්ත්‍රික් ප්‍රථම යා හා දෙවෙනියාද බිහිකිරීමට සමත් විය.රුහුණු විශ්ව විද්‍යාලයේ
                                        විද්‍යා වේදී විශේෂ උපාධිය අවසන් කර ඇති අතර ජාතික අධ්‍යාපන ආයතනය මගින් පැවැත්වූ
                                        සෑම සැසියමට සහභාගි වෙමින් නව විශය නිර්දේශය හොදින් ග්‍රහණය කරගෙන ඇත...වසර 14ක
                                        පලපුරුද්ද නුබේ ලේ වලටම chemistry කාවැද්දීමට සමත්‍ ය.
                                    </p>
                                </div>
                            </p>
                        </div>
                    </section>

                    {
                        this.state.classes.length === 0 && !this.props.isSpinner &&
                        <NotFound message={`Available classes`}/>
                    }

                    {
                        this.state.classes.length !== 0 &&
                        <section className=" class-section">
                            <div className="about2">
                                <h3 className={"class-topic"}>Classes</h3></div>
                            {/* <h3 className={"class-ctrl"}>Classes</h3> */}
                            <CourseSlides classesByLecture={this.state.classes} privileges={this.state.privileges}/>
                        </section>
                    }

                    {
                        (this.state.privileges === '1' && this.state.lessons.length !== 0) &&
                        <section className=" class-section">
                            <div className="about2">
                                <h3 className={"class-topic"}>Lesson Videos</h3></div>
                            {/* <h3 className={"class-ctrl"}>Classes</h3> */}
                            <LessonItem lessons={this.state.lessons}/>
                        </section>
                    }

                </main>
                <CardsFooter/>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    lecturer: state.lecturer.lecturer,
    listOfLectures: state.classes.listOfLectures,
    pagination: state.classes.pagination,
    isSpinner: state.spinner.isSpinner,
    userType: state.auth.userType,
});
const mapDispatchToProps = (dispatch) => ({
    spinnerHandler: data => dispatch(actionSpinnerCreator.spinnerHandler(data)),
    fetchLectures: data => dispatch(actionClassCreator.fetchLectures(data)),
    fetchLecture: data => dispatch(actionLectureCreator.fetchLecture(data)),
    selectPagination: data => dispatch(actionClassCreator.selectPagination(data)),
});
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Teacher));
